import { Autocomplete, Button, Card, CardActions, CardContent, Grid, TextField } from "@mui/material";
import dayjs from "dayjs";
import { useCallback, useContext, useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { v4 } from "uuid";
import { GlobalContext } from "../../../../../../../../util/state/GlobalContextProvider";
import { messagesState } from "../../../../recoil";
import { Message } from "../../../../types";

const MOCK_RECIPIENTS: Message['recipients'] = [
    {
        id: '1',
        label: 'marco@gmail.com'
    },
    {
        id: '2',
        label: 'luca@gmail.com'
    }
]

const NewMessage = ({
    show,
    onClose
}: {
    show: boolean,
    onClose: () => void
}) => {

    // Use Context
    const { globalData } = useContext(GlobalContext);

    // Use Recoil
    const [messages, setMessages] = useRecoilState(messagesState);

    // Use State
    const [body, setBody] = useState<string>('');
    const [recipients, setRecipients] = useState<Message['recipients']>([]);
    const [subject, setSubject] = useState<string>('');

    // Use Callback
    const handleClickSend = useCallback(() => {
        setTimeout(() => {
            const [...currentMessages]: Message[] = messages;
            currentMessages.push({
                id: v4(),
                user: globalData.user.username,
                timestamp: dayjs().format('DD-MM-YYYY HH:mm'),
                recipients,
                subject,
                body
            });
            setMessages(currentMessages);
            onClose();
        }, 1000);
    }, [recipients, subject, body, globalData.user.username]);

    // Use Effect
    useEffect(() => {
        if (!show) {
            setBody('');
            setRecipients([]);
            setSubject('');
        }
    }, [show]);

    if (!show)
        return <></>;

    return (
        <Card
            variant="outlined"
            sx={{
                borderColor: 'primary.main'
            }}
        >
            <CardContent>
                <Grid container direction="row" alignItems="center">
                    <Grid item width={100}>
                        To:
                    </Grid>
                    <Grid item xs>
                        <Autocomplete
                            openOnFocus
                            autoHighlight
                            autoSelect
                            value={recipients}
                            onChange={(e, value) => {
                                setRecipients(value);
                            }}
                            options={MOCK_RECIPIENTS}
                            fullWidth
                            multiple
                            isOptionEqualToValue={(opt, value) => opt.id === value.id}
                            renderInput={(props) =>
                                <TextField
                                    {...props}
                                    autoFocus
                                    variant="outlined"
                                />
                            }
                        />
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="center">
                    <Grid item width={100}>
                        Subject:
                    </Grid>
                    <Grid item xs>
                        <TextField
                            variant="outlined"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            fullWidth
                            autoComplete="off"
                        />
                    </Grid>
                </Grid>
                <TextField
                    value={body}
                    onChange={(e) => setBody(e.target.value)}
                    placeholder="Type something here..."
                    size="small"
                    fullWidth
                    multiline
                    maxRows={8}
                    InputProps={{
                        disableUnderline: true
                    }}
                    sx={{
                        mt: 4
                    }}
                />
            </CardContent>
            <CardActions sx={{
                justifyContent: 'end'
            }}>
                <Button
                    onClick={handleClickSend}
                    disabled={body === '' || recipients.length === 0 || subject === ''}
                >
                    Send
                </Button>
                <Button
                    variant="outlined"
                    onClick={onClose}
                >
                    Cancel
                </Button>
            </CardActions>
        </Card>
    )
};

export default NewMessage;